import React from 'react';
import GeneralModal from '../../../../components/GeneralModal/GeneralModal';
import { useDeleteEquipmentMutation } from '../../../../store/builder/inspections.api';
import { toast } from 'react-toastify';
import { useTranslation } from '../../../../hooks/useTranslation';

const ArchiveToolModal = ({ toolId, setIsOpen, onArchiveSuccess }) => {
  const {t} = useTranslation();
  const [
    archiveEquipment,
    { isLoading: archiveIsLoading },
  ] = useDeleteEquipmentMutation();

  const handleArchive = () => {
        archiveEquipment(toolId).then((res) => {
            if (res?.data?.message) {
                toast.success(res?.data?.message);
            }
            if (res?.error) {
                toast.error(res?.error?.data?.message);
            }
            setIsOpen(false);
            if (onArchiveSuccess) {
                onArchiveSuccess();
            }
        });
    }

  return (
    <GeneralModal
      title=""
      onClose={() => setIsOpen(false)}
      onSubmit={handleArchive}
      submitTitle={t('equipmentTable.actions.archive')}
      cancelTitle={t('toolsManagement.modals.buttons.close')}
      btnType='delete'
      disableSubmit={archiveIsLoading}
    >
      <div
        className='modal__content-body'
        style={{display: 'flex', justifyContent: 'center'}}
      >
        <p className='modal__content-dangerText'>
          {t('equipmentTable.messages.archiveEquipment')}
        </p>
      </div>
    </GeneralModal>
  );
};

export default ArchiveToolModal;
